__turbopack_context__.v({
  "btn-category-icon-left": "category-selector-module-scss-module__70nYaa__btn-category-icon-left",
  "btn-category-icon-right": "category-selector-module-scss-module__70nYaa__btn-category-icon-right",
  "button-category": "category-selector-module-scss-module__70nYaa__button-category",
  "button-category-text": "category-selector-module-scss-module__70nYaa__button-category-text",
  "filter-button": "category-selector-module-scss-module__70nYaa__filter-button",
  "focused": "category-selector-module-scss-module__70nYaa__focused",
});
